import { createPortal } from 'react-dom';

// La foto tonda di un musicista a tutto schermo; si chiude toccando ovunque.
// Sta nel body (portal): dentro una pagina con un transform, position:fixed
// si aggancerebbe alla pagina invece che allo schermo, e la foto finiva in basso.
function FotoIntera({ src, onClose }) {
  return createPortal(
    <div onClick={onClose}
      style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.92)',display:'flex',
        alignItems:'center',justifyContent:'center',zIndex:10001,cursor:'pointer'}}>
      <img src={src} alt=""
        style={{width:'min(400px, 88vw)',height:'min(400px, 88vw)',borderRadius:'50%',objectFit:'cover'}}/>
    </div>,
    document.body
  );
}

export default FotoIntera;
